module.exports = __webpack_public_path__ + "img/b_23.318bd5f7.jpg";